module.exports = __webpack_public_path__ + "static/media/trash.9ca416fd.svg";